import { createAsyncThunk } from '@reduxjs/toolkit';

import { modelosNotificacaoService } from './services';
import type {
  CreateModeloNotificacaoDto,
  ModeloNotificacao,
  UpdateModeloNotificacaoDto,
} from '../types/modeloNotificacaoTypes';

const toErrorMessage = (error: unknown, fallback: string): string =>
  error instanceof Error ? error.message : fallback;

export const listarModelosNotificacao = createAsyncThunk<
  ModeloNotificacao[],
  void,
  { rejectValue: string }
>('modelosNotificacao/listar', async (_, { rejectWithValue }) => {
  try {
    return await modelosNotificacaoService.listar();
  } catch (error) {
    return rejectWithValue(toErrorMessage(error, 'Não foi possível carregar os modelos.'));
  }
});

export const buscarModeloNotificacao = createAsyncThunk<
  ModeloNotificacao,
  string,
  { rejectValue: string }
>('modelosNotificacao/buscar', async (id, { rejectWithValue }) => {
  try {
    return await modelosNotificacaoService.buscar(id);
  } catch (error) {
    return rejectWithValue(toErrorMessage(error, 'Não foi possível carregar o modelo.'));
  }
});

export const criarModeloNotificacao = createAsyncThunk<
  ModeloNotificacao,
  CreateModeloNotificacaoDto,
  { rejectValue: string }
>('modelosNotificacao/criar', async (data, { rejectWithValue }) => {
  try {
    return await modelosNotificacaoService.criar(data);
  } catch (error) {
    return rejectWithValue(toErrorMessage(error, 'Não foi possível criar o modelo.'));
  }
});

export const atualizarModeloNotificacao = createAsyncThunk<
  ModeloNotificacao,
  { id: string; data: UpdateModeloNotificacaoDto },
  { rejectValue: string }
>('modelosNotificacao/atualizar', async ({ id, data }, { rejectWithValue }) => {
  try {
    return await modelosNotificacaoService.atualizar(id, data);
  } catch (error) {
    return rejectWithValue(toErrorMessage(error, 'Não foi possível salvar o modelo.'));
  }
});

export const alternarStatusModeloNotificacao = createAsyncThunk<
  ModeloNotificacao,
  string,
  { rejectValue: string }
>('modelosNotificacao/alternarStatus', async (id, { rejectWithValue }) => {
  try {
    return await modelosNotificacaoService.alternarStatus(id);
  } catch (error) {
    return rejectWithValue(toErrorMessage(error, 'Não foi possível atualizar o status.'));
  }
});
